import { post } from "@insite/client-framework/Services/ApiService";
import { CartModel } from "@insite/client-framework/Types/ApiModels";

const updateCartURL = "/api/v1/Iterable/updatecart";
const trackPurchaseURL = "/api/v1/Iterable/trackpurchase";

export async function updateCartForIterable(parameter: CartModel) {
    // Abandoned Cart V2 Iterable
    const apiResult = await post<CartModel>(`${updateCartURL}`, parameter);
    
    return apiResult;
}


export async function trackPurchaseForIterable(parameter: CartModel) {
    // Abandoned Cart V2 Iterable
    const apiResult = await post<CartModel>(`${trackPurchaseURL}`, parameter);
    
    return apiResult;
}